import React from 'react';

const StepSidebar = ({
  currentStep, setStep, stepDefs, stepOrder,
  isFinalised, draftId, onCreateDraft,
  onExportPdf, isExporting, onFinalise,
  confirmFinalise, setConfirmFinalise,
  onTogglePreview, showPreview, onReset,
}) => {
  return (
    <div className="soa-sidebar">
      <h6 className="text-uppercase small fw-bold text-muted mb-3" style={{ letterSpacing: '0.5px' }}>
        Steps
      </h6>

      {stepOrder.map((key, idx) => (
        <div
          key={key}
          className={`soa-sidebar-step ${currentStep === idx + 1 ? 'active' : ''}`}
          onClick={() => setStep(idx + 1)}
        >
          <span className="step-number">{idx + 1}</span>
          <span>{stepDefs[key].label}</span>
        </div>
      ))}

      <hr className="my-3" />

      {/* Actions */}
      <div className="d-flex flex-column gap-2">
        {!draftId && (
          <button className="btn btn-primary btn-sm w-100" onClick={onCreateDraft}>
            <i className="bi bi-save me-1"></i>Save Draft
          </button>
        )}

        <button
          className={`btn btn-sm w-100 ${showPreview ? 'btn-secondary' : 'btn-outline-secondary'}`}
          onClick={onTogglePreview}
        >
          <i className={`bi ${showPreview ? 'bi-eye-slash' : 'bi-eye'} me-1`}></i>
          {showPreview ? 'Hide Preview' : 'Preview'}
        </button>

        <button
          className="btn btn-outline-primary btn-sm w-100"
          onClick={onExportPdf}
          disabled={isExporting}
        >
          {isExporting ? (
            <><i className="bi bi-arrow-repeat spin me-1"></i>Generating...</>
          ) : (
            <><i className="bi bi-file-earmark-pdf me-1"></i>Export PDF</>
          )}
        </button>

        {draftId && !isFinalised && (
          <>
            {confirmFinalise ? (
              <div className="d-flex gap-1">
                <button className="btn btn-danger btn-sm flex-grow-1" onClick={onFinalise}>
                  Confirm
                </button>
                <button className="btn btn-outline-secondary btn-sm" onClick={() => setConfirmFinalise(false)}>
                  Cancel
                </button>
              </div>
            ) : (
              <button className="btn btn-success btn-sm w-100" onClick={onFinalise}>
                <i className="bi bi-lock me-1"></i>Finalise SOA
              </button>
            )}
          </>
        )}

        <button className="btn btn-outline-danger btn-sm w-100 mt-1" onClick={onReset}>
          <i className="bi bi-arrow-counterclockwise me-1"></i>New SOA
        </button>
      </div>
    </div>
  );
};

export default StepSidebar;
